import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ShareService } from "app/service/share/share.service";
import { AuthService } from "../service/auth/auth.service";
import { GtmService } from "../service/gtm/gtm.service";
import { HttpService } from "../service/http/http.service";
import { NotificationService } from "../service/notification/notification.service";

declare let window: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [NotificationService],
})
export class LoginComponent implements OnInit {
  error: string = "";
  id: string;

  logoPos: number;
  formPos: number;

  emailKey: string = "heyground-email";
  isRememberEmail: boolean = false;

  constructor(
    private httpService: HttpService,
    private shareService: ShareService,
    private router: Router,
    private authService: AuthService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private gtmService: GtmService
  ) {
    this.logoPos = 0; // (window.innerHeight - 80 - 355) / 2;
    this.formPos = 0; // window.innerHeight - (this.logoPos + 80 + 390);

    let email = localStorage.getItem(this.emailKey);
    this.id = email ? email : "";

    if (this.authService.canActivate()) {
      this.router.navigateByUrl("/");
    } else {
      this.gtmService.pageViewWithPage({
        path: this.route.snapshot["_routerState"].url,
        title: "Member Login",
        breadcrumb: "Home > Member Login",
      });
    }

    window.ChannelIO('shutdown');
  }

  isAppLogin: boolean = false;

  ngOnInit() {
    this.isAppLogin =
      window.navigator.userAgent.indexOf("hey_application") > -1 &&
      location.href.includes("login");
  }

  login(form: any) {
    if (!form.id) {
      window.alert("아이디를 입력해 주세요.");
      return;
    } else if (!form.pw) {
      window.alert("패스워드를 입력해 주세요.");
      return;
    }

    this.httpService.login(form.id, form.pw).subscribe(
      (res) => {
        if (this.isRememberEmail) localStorage.setItem(this.emailKey, form.id);

        this.httpService.saveToken(res);
        this.gtmService.loginEvent();
        this.shareService.refreshMe();

        // issue-210510
        const locKey = "__hey_policy_" + this.authService.getEmail();
        const processStep = localStorage.getItem(locKey);

        if (!processStep) {
          localStorage.setItem(locKey, "logout");
        }

        let isApp = window.navigator.userAgent.indexOf("hey_application") > -1;
        if (isApp) {
          this.router.navigateByUrl("/member/home");
        } else if (this.authService.redirect)
          this.router.navigateByUrl(this.authService.redirect);
        else this.router.navigateByUrl("/member/community");
      },
      (error) => {
        let errorBody = JSON.parse(error._body);
        this.error =
          errorBody &&
            (errorBody.error_description.indexOf("만료") !== -1 ||
              errorBody.error_description.indexOf("expired") !== -1)
            ? "invalid_grant"
            : "password";
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts